import { SizeDropDownUI } from "./SizeDropDownUI";
import { StandardProps } from "../componentMap";
import { useRouter } from "next/router";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Variant } from "../../types/types";
import { getSizeReductionLabelInfo } from "../../utils/product/getSizeReductionLabelInfo";
import { getVariantDimensions } from "../../utils/product/getVariantDimensions";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";
import { isFutureRelease } from "../../utils/variant/isFutureRelease";
import { createSelectedSizeUrlObj } from "../Sizes/utils/createSelectedSizeUrl";
import { FitToolAndSizeChart } from "../FitToolAndSizeChart/FitToolAndSizeChart";

export function SizeDropDown({
  product,
  configProps,
  runtimeConfig,
}: Pick<StandardProps, "product" | "configProps" | "runtimeConfig">) {
  const router = useRouter();

  const { variant, isSelected } = useVariant(product);

  const handleClick = (newSize: string) => {
    const targetUrl = createSelectedSizeUrlObj(newSize, router.query, variant);
    router.push(targetUrl, undefined, { shallow: true, scroll: false });
  };

  const variants: Variant[] = product.variants;
  const sizeVariants = variants.filter((v) => {
    if (variant.differentiators?.colour) {
      return (
        v.differentiators?.size &&
        v.differentiators?.colour === variant.differentiators?.colour
      );
    } else {
      return v.differentiators?.size;
    }
  });

  const uniqueSizes = sizeVariants.map((sizeVariant) => {
    const { showReduced, label } = getSizeReductionLabelInfo(
      product,
      sizeVariant,
    );

    return {
      name: sizeVariant.differentiators?.size,
      sublabel: getVariantDimensions(sizeVariant),
      sizeReductionLabel: label,
      showReduced: showReduced,
      unavailable:
        !sizeVariant.availability?.availableToOrder &&
        !isInStoreOnly(sizeVariant) &&
        !isFutureRelease(sizeVariant),
      isSelected: sizeVariant.id === variant.id && isSelected,
    };
  });

  return (
    <>
      {configProps?.withFitToolAndSizeChart ? (
        <FitToolAndSizeChart product={product} runtimeConfig={runtimeConfig} />
      ) : null}
      <SizeDropDownUI uniqueSizes={uniqueSizes} handleClick={handleClick} />
    </>
  );
}
